var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParcelShopsafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "parcelShops_after_svg__Ebene_1",
    "data-name": "Ebene 1",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 991.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parcelShops_after_svg__cls-12,.parcelShops_after_svg__cls-13,.parcelShops_after_svg__cls-14,.parcelShops_after_svg__cls-15,.parcelShops_after_svg__cls-19,.parcelShops_after_svg__cls-22,.parcelShops_after_svg__cls-23,.parcelShops_after_svg__cls-24,.parcelShops_after_svg__cls-29,.parcelShops_after_svg__cls-30,.parcelShops_after_svg__cls-31,.parcelShops_after_svg__cls-33,.parcelShops_after_svg__cls-34,.parcelShops_after_svg__cls-36,.parcelShops_after_svg__cls-44,.parcelShops_after_svg__cls-46,.parcelShops_after_svg__cls-47,.parcelShops_after_svg__cls-48,.parcelShops_after_svg__cls-49,.parcelShops_after_svg__cls-5,.parcelShops_after_svg__cls-57,.parcelShops_after_svg__cls-58,.parcelShops_after_svg__cls-59,.parcelShops_after_svg__cls-6,.parcelShops_after_svg__cls-60,.parcelShops_after_svg__cls-61,.parcelShops_after_svg__cls-7,.parcelShops_after_svg__cls-8,.parcelShops_after_svg__cls-9{stroke:#343a50}.parcelShops_after_svg__cls-12,.parcelShops_after_svg__cls-13,.parcelShops_after_svg__cls-15,.parcelShops_after_svg__cls-29,.parcelShops_after_svg__cls-30,.parcelShops_after_svg__cls-36,.parcelShops_after_svg__cls-37,.parcelShops_after_svg__cls-44,.parcelShops_after_svg__cls-46,.parcelShops_after_svg__cls-47,.parcelShops_after_svg__cls-48,.parcelShops_after_svg__cls-49,.parcelShops_after_svg__cls-5,.parcelShops_after_svg__cls-58,.parcelShops_after_svg__cls-59,.parcelShops_after_svg__cls-6,.parcelShops_after_svg__cls-61,.parcelShops_after_svg__cls-7,.parcelShops_after_svg__cls-8,.parcelShops_after_svg__cls-9{stroke-miterlimit:10}.parcelShops_after_svg__cls-12,.parcelShops_after_svg__cls-13,.parcelShops_after_svg__cls-22,.parcelShops_after_svg__cls-30,.parcelShops_after_svg__cls-34,.parcelShops_after_svg__cls-36,.parcelShops_after_svg__cls-44,.parcelShops_after_svg__cls-48,.parcelShops_after_svg__cls-49,.parcelShops_after_svg__cls-5,.parcelShops_after_svg__cls-57,.parcelShops_after_svg__cls-59,.parcelShops_after_svg__cls-6,.parcelShops_after_svg__cls-60,.parcelShops_after_svg__cls-61,.parcelShops_after_svg__cls-7,.parcelShops_after_svg__cls-8{stroke-width:2px}.parcelShops_after_svg__cls-41{fill:#7fc3ca}.parcelShops_after_svg__cls-3{fill:#eb9a6b}.parcelShops_after_svg__cls-4{fill:#343a50}.parcelShops_after_svg__cls-46,.parcelShops_after_svg__cls-5{fill:#bc2a2b}.parcelShops_after_svg__cls-47,.parcelShops_after_svg__cls-6{fill:#c65d5d}.parcelShops_after_svg__cls-60,.parcelShops_after_svg__cls-7{fill:#aa2020}.parcelShops_after_svg__cls-8{fill:#936652}.parcelShops_after_svg__cls-13,.parcelShops_after_svg__cls-22,.parcelShops_after_svg__cls-24,.parcelShops_after_svg__cls-31,.parcelShops_after_svg__cls-33,.parcelShops_after_svg__cls-9{fill:#ffccb5}.parcelShops_after_svg__cls-9{stroke-width:3px}.parcelShops_after_svg__cls-12{fill:#46bea9}.parcelShops_after_svg__cls-14,.parcelShops_after_svg__cls-15,.parcelShops_after_svg__cls-19,.parcelShops_after_svg__cls-23,.parcelShops_after_svg__cls-37{fill:none}.parcelShops_after_svg__cls-14,.parcelShops_after_svg__cls-15,.parcelShops_after_svg__cls-19,.parcelShops_after_svg__cls-22,.parcelShops_after_svg__cls-23,.parcelShops_after_svg__cls-24,.parcelShops_after_svg__cls-31,.parcelShops_after_svg__cls-33,.parcelShops_after_svg__cls-34,.parcelShops_after_svg__cls-57,.parcelShops_after_svg__cls-60{stroke-linecap:round}.parcelShops_after_svg__cls-14,.parcelShops_after_svg__cls-19,.parcelShops_after_svg__cls-22,.parcelShops_after_svg__cls-23,.parcelShops_after_svg__cls-24,.parcelShops_after_svg__cls-31,.parcelShops_after_svg__cls-33,.parcelShops_after_svg__cls-34,.parcelShops_after_svg__cls-57,.parcelShops_after_svg__cls-60{stroke-linejoin:round}.parcelShops_after_svg__cls-16{fill:#fff}.parcelShops_after_svg__cls-17,.parcelShops_after_svg__cls-36{fill:#343a51}.parcelShops_after_svg__cls-19{stroke-width:1.21px}.parcelShops_after_svg__cls-23{stroke-width:.86px}.parcelShops_after_svg__cls-24{stroke-width:1.29px}.parcelShops_after_svg__cls-29{fill:#389694}.parcelShops_after_svg__cls-29,.parcelShops_after_svg__cls-31{stroke-width:2.06px}.parcelShops_after_svg__cls-30{fill:#68493e}.parcelShops_after_svg__cls-33{stroke-width:1.31px}.parcelShops_after_svg__cls-34{fill:#ffbb68}.parcelShops_after_svg__cls-35{fill:#c3c7ca}.parcelShops_after_svg__cls-37{stroke:#343a51;stroke-width:.57px}.parcelShops_after_svg__cls-41{opacity:.56}.parcelShops_after_svg__cls-44{fill:#c6c6c4}.parcelShops_after_svg__cls-57,.parcelShops_after_svg__cls-58,.parcelShops_after_svg__cls-59{fill:#2a2118}.parcelShops_after_svg__cls-46,.parcelShops_after_svg__cls-47{stroke-width:2px}.parcelShops_after_svg__cls-48{fill:#271b1d}.parcelShops_after_svg__cls-49{fill:#d9dbda}.parcelShops_after_svg__cls-58{stroke-width:1.21px}.parcelShops_after_svg__cls-61{fill:#665948}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Paket-Caf\\xE9_Nachher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Haus_hinten"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "parcelShops_after_svg__Wand",
    fill: "#a8927b",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "1259.01 829.12 -.99 829.12 -1.02 -89.84 1259.03 -89.86 1259.01 829.12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 326.3,
    x: 20.14,
    y: 343.97,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.6 670.27 109.6 518.01 20.15 518.01 20.15 496.31 109.6 496.31 109.6 343.96 131.25 343.96 131.25 496.31 220.62 496.31 220.62 518.01 131.25 518.01 131.25 670.27 109.6 670.27",
    className: "parcelShops_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.26 345v152.3h89.37V517h-89.37v152.27H110.6V517H21.14v-19.7h89.46V345h19.66m2-2h-23.65v152.31H19.15V519h89.46v152.26h23.64V519h89.37v-23.69h-89.37V343z",
    className: "parcelShops_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Dach"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1232.63,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-5",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1144.57,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-6",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.21,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-5",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 968.46,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-6",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 880.09,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-5",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 792.47,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-6",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 704.1,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-5",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 615.74,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-6",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.44,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-5",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.14,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-6",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 350.8,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-5",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.48,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-6",
    rx: 47.97,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.38,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-5",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.27,
    cy: 163.62,
    className: "parcelShops_after_svg__cls-6",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.71 163.62c0-32.83-19.94-59.66-45.7-61.87l.08 123.73c25.76-2.21 45.62-29.02 45.62-61.86z",
    className: "parcelShops_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.01 142.58 -.99 142.53 -1 -89.84 1259.01 -89.85 1259.01 142.58",
    className: "parcelShops_after_svg__cls-7"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 67.58,
    height: 74.77,
    x: 1131.71,
    y: 656.02,
    className: "parcelShops_after_svg__cls-7",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Mann"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1151.84 610.37c-2.54-.48-5 .17-6.37 1.85a6.78 6.78 0 00-1.24 3.71 11.47 11.47 0 00.41 3.08 22.45 22.45 0 01.21 5.14c-.09 6.63-.17 12.22 2.06 15s5.34 1.37 30.83-2.68c5.24-.83 10.06-1.56 12.54-5.34 1.1-1.67 1.49-4 2.27-8.64.84-5 .35-6.58-.21-7.6a6.79 6.79 0 00-3.91-3.29c-2.8-.74-4.77 1.34-12.33 5.34-5.73 3-6.79 3-7.61 2.68-3-1.22-2.08-6.18-5.55-7.61-1.75-.73-2.61.29-6.17-.21a17.47 17.47 0 01-4.93-1.43z",
    className: "parcelShops_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1123.47 686.03 1118.64 712.35 1137.85 712.88 1142.39 709.36 1141.87 693.23 1123.47 686.03",
    className: "parcelShops_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1218.24 714.5 1211.87 683.97 1191.34 689.01 1196.45 708.64 1199.84 714.5 1218.24 714.5",
    className: "parcelShops_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b36375",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1123 688c.37-1.36.91-3.43 1.55-6s.89-3.6 1-4.11a18.58 18.58 0 016.89-9.66 19.56 19.56 0 015.35-2.88 21 21 0 016.88-1.13c.55 0 .58 0 3 .1l6.16.21c5.46.17 23.94.19 32.38-.21.37 0 2.55-.12 5.45 0a24.38 24.38 0 014.52.41 17.39 17.39 0 016.27 3 28.8 28.8 0 013.5 3 20.76 20.76 0 011.95 2.06 20 20 0 012.78 5 29.57 29.57 0 011.44 3.8 24.3 24.3 0 01.92 6l-15.52 8.95 2.36 18-62.6-1.64L1139 697z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.04,
    height: 48.72,
    x: 1157.16,
    y: 664.65,
    fill: "#d8d8d8",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.05 656.22s-2.55.82-4.93 5.24a14.41 14.41 0 00-.9 2.11 21.31 21.31 0 00.3 13.26l.52 1.34a1.92 1.92 0 001.23.2c.38-.08 1-.35 2-2.26.78-1.53.55-1.66 1-2.47a7.48 7.48 0 013.7-2.77c2-.87 2.29-.42 3.5-1.13a7 7 0 002.88-4c.81-3.15-1-6.26-3.09-7.92-.62-.42-3.43-2.49-6.21-1.6zM1183.29 658.07a17.06 17.06 0 013 4.11c3.39 6.56 2 13.85.1 15.73a1.52 1.52 0 01-1 .51c-1.09 0-1.75-1.79-2.57-3.18A15.09 15.09 0 001177 670c-3.6-2.13-5-.88-6.57-2.67-1.87-2.19-1.46-6.18.2-8.84 1.26-2 3.81-4.2 6.79-4 2.47.14 4.17 1.86 5.87 3.58z",
    className: "parcelShops_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.78 631.34a12.44 12.44 0 00-6.57-1 4.42 4.42 0 00-3.09 1.23c-.41.49-.56 1-.62 3.91-.08 4.51.26 5.35.83 6a3.85 3.85 0 001.85 1c2.87.81 12.87 2.29 14.39-1.65 1.13-2.97-2.95-7.63-6.79-9.49zM1181.86 630.93c1-.75 1.45-.71 12.13-.41a4.08 4.08 0 013.08 1c.34.38.58.9.62 3.7 0 4.48-.54 5.53-.83 6a4.39 4.39 0 01-1.64 1.65c-1.85 1-3.85-.15-6.79-1.24-6.42-2.37-8.28-1.25-9.25-3.08-1.18-2.19.4-5.84 2.68-7.62zM1160.47 664a8 8 0 002.06 3.29c3 2.74 7.09 1.92 7.4 1.85a9.08 9.08 0 005.55-3.9 9 9 0 00.41-9.26 8.29 8.29 0 00-3.49-3.08c-2.76-1.4-7.84-2.3-10.9.82-3.5 3.64-1.33 9.49-1.03 10.28z",
    className: "parcelShops_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.06 640a20.82 20.82 0 002.26 9.46 22 22 0 006 7.81 23.14 23.14 0 007.37 4h.11a25.74 25.74 0 0014.64-.1 21.71 21.71 0 003.17-1.23 22.92 22.92 0 0010.69-11.31c1.25-3 1.49-5.51 1.85-9.25a78.44 78.44 0 00.2-8.84 46.39 46.39 0 00-.2-4.93 20.87 20.87 0 00-4.32-9.66c-1.13-1.5-6.79-9-16.86-9.67a25.31 25.31 0 00-15.7 5.25 22.21 22.21 0 00-2 1.74c-1.61 1.58-5.39 5-6.17 10.08-.09.63-.32 2.57-.41 4.93-.06 1.85 0 2.78 0 4.11-.01 4.08-.59 5.02-.63 7.61z",
    className: "parcelShops_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.56 641.52a4.46 4.46 0 00.41 2.36 4.79 4.79 0 003.29 2.47 4.59 4.59 0 004-1.13 4.49 4.49 0 001.23-3.49",
    className: "parcelShops_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.09 629a4.59 4.59 0 011.53-1.33 4.5 4.5 0 012.43-.48 5.59 5.59 0 013.39 1.43M1176.15 628.12a7.19 7.19 0 012-.67 5.4 5.4 0 013.44.24 4.71 4.71 0 012 1.95",
    className: "parcelShops_after_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.84 633a5 5 0 01-.56-.46 5.74 5.74 0 013.55-1.34 5.87 5.87 0 014.17 1.8 7 7 0 01-.67.31c-.21.14-3.86 1.56-6.49-.31z",
    className: "parcelShops_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.16,
    cy: 632.61,
    r: 1.27,
    className: "parcelShops_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.15 633a4.22 4.22 0 01-.56-.46 5.67 5.67 0 013.54-1.34 5.87 5.87 0 014.22 1.8c-.12.06-.36.18-.67.31s-3.9 1.56-6.53-.31z",
    className: "parcelShops_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1179.47,
    cy: 632.61,
    r: 1.27,
    className: "parcelShops_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.73,
    d: "M1193.68 640.07a2.32 2.32 0 01.46 0 3 3 0 11-2.8 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.2 635.35a4.89 4.89 0 011.47-.38l1.92-.09M1194.7 635.12a5 5 0 00-1.47-.39l-1.92-.08",
    className: "parcelShops_after_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.31 649.87a13.39 13.39 0 005 2.49c1.49.38 3.51.23 7.53-.06 2.56-.19 3.47-.37 4.4-1a6 6 0 002.17-2.93",
    className: "parcelShops_after_svg__cls-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Junge"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1035.09 739.07c.15-2.93.35-7.78.34-13.79 0-15.95-1.46-20.62.34-30.29a65.14 65.14 0 014.6-14.64c.48-1.07 3.44-5.6 9.36-14.64 1.61-2.45 2.93-4.42 4.77-4.43 1.56 0 2.09 1.42 5.62 4.94 3.35 3.35 4.11 3.29 7 6.47a53.34 53.34 0 013.41 4.25c2 2.76 5.21 8.13 8.34 18.56a116.06 116.06 0 014.25 21.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1051.26 655.5a4.91 4.91 0 01-2.55-.34c-2.09-1-2.73-3.45-3.23-4.94-1.47-4.37-2.69-3.28-7.66-11.75-2.35-4-3.53-6-4.26-8.17-2.64-7.84-.26-17.34 4.6-24 6.25-8.57 15.43-10.81 18.55-11.57 6.27-1.53 11.66-.91 21.11.17a122.1 122.1 0 0112.25 2 18.26 18.26 0 00-8.17 4.43l12.26.51a12.54 12.54 0 010 2.21c-.54 5.58-5 9.11-5.79 9.7-5 3.78-8 .8-11.74 3.58-5.58 4.1-.44 11.65-6.47 22.64-2.2 4-5.15 6.58-11.07 11.74-1.02.93-3.98 3.46-7.83 3.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.31 653.79a80.59 80.59 0 008.09 4.24l.42.19c3.82 1.71 7.24 3 10.89 2.38a4.93 4.93 0 002.21-1 8.75 8.75 0 003.07-4.25 23.22 23.22 0 001-11.15c0-.08-.17-.44 0-.61a.5.5 0 01.39-.08 6.89 6.89 0 002.81-.19 2.09 2.09 0 001.09-1 2.31 2.31 0 00.06-1.59 5.34 5.34 0 00-1-2 8.66 8.66 0 01-1.12-1.74 5.76 5.76 0 00-.29-.84 11.64 11.64 0 01-.48-1.91 19.43 19.43 0 01-.43-4 19 19 0 01.68-3.83 20 20 0 00.43-7.57 8.79 8.79 0 00-1.54-4.17 8.68 8.68 0 00-5.36-3.07c-.87-.19-5.49-1.08-8.34 1.7a8.64 8.64 0 00-1.87 3.41c-1.78 4.52-.79 5.85-2.21 9.36-1 2.49-3.17 5.94-5.62 6a2.72 2.72 0 01-1.7-.51c-.78-.63-.63-1.47-1.53-3.58a4.27 4.27 0 00-.85-1.53 3.65 3.65 0 00-4.09 0 5 5 0 00-1.87 3.4 12.13 12.13 0 00.34 6.47c.67 2.12 1.41 2.62 1.7 4.77a11.12 11.12 0 010 2.89c-.44 3.78-2 7.44-3.06 10-2.44 6.16-3.88 9.94-2.22 11.92.36.42.57.43 2.09 1.15 4.06 1.92 4.29 2.68 8 4.59 1.39.71 6.78 3.46 7.53 2.43.22-.3 0-.77-.38-1.53a20.18 20.18 0 01-1.4-6.26c-.47-3.89.56-6.76 1-6.76.09 0 3 .35 3.25.32 0 0 1.61.09 1.6.08s-.66.05 1.18 0",
    className: "parcelShops_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 626.15a4 4 0 012.24-1.4 4.2 4.2 0 013.36.84",
    className: "parcelShops_after_svg__cls-23"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.82,
    cy: 631.19,
    className: "parcelShops_after_svg__cls-16",
    rx: 2.8,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1082.68,
    cy: 631.33,
    className: "parcelShops_after_svg__cls-4",
    rx: 0.98,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.58 651.5a14 14 0 01-6.46-1.62 13.25 13.25 0 01-2-1.36c.87.14 1.81.24 2.8.31a30.57 30.57 0 006.41-.3",
    className: "parcelShops_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.73 630.39a3.42 3.42 0 011.28 1.28 4.22 4.22 0 01-.13 3.83",
    className: "parcelShops_after_svg__cls-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 91.92,
    x: -1,
    y: 900.22,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 901.22v89.93H0v-89.93h1258m2-2H-2v93.93h1262v-93.93z",
    className: "parcelShops_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Boden"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "parcelShops_after_svg__Boden-2",
    fill: "#a5714e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "-.96 857.26 1259.01 857.42 1259.01 829.12 -.99 829.12 -.96 857.26",
    "data-name": "Boden"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 46.6,
    x: -1,
    y: 853.7,
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 854.7v44.59H0V854.7h1258m2-2H-2v48.59h1262V852.7z",
    className: "parcelShops_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Haus_klein"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b4b45",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2.16,
    points: "644.28 663.12 579.68 663.12 575.2 692.41 647.2 692.41 644.28 663.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.72 708h1.57c-.51-13.57-.47-24.66-.33-32.38.25-13.73.88-21.16-.5-33.69a113.56 113.56 0 00-4.13-20.65c-3-10.11-6.18-15.33-8.09-18a52.91 52.91 0 00-3.31-4.13c-2.78-3.08-3.51-3-6.77-6.28-3.42-3.41-3.93-4.79-5.45-4.79-1.78 0-3.07 1.92-4.62 4.3-5.75 8.77-8.62 13.16-9.09 14.2a63.83 63.83 0 00-4.46 14.21c-1.75 9.39-.35 13.92-.33 29.4 0 5.83-.18 10.53-.33 13.38l.67 43.44c.58 0 1.51.07 2.64.16a84.39 84.39 0 0110.41 1.49c4.18.83 13.75 2.72 21.47.82a45.22 45.22 0 0110.65-1.48z",
    className: "parcelShops_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.57 582.51a4.73 4.73 0 01-2.47-.33c-2-.93-2.66-3.35-3.14-4.79-1.42-4.25-2.61-3.19-7.43-11.4-2.28-3.88-3.42-5.82-4.13-7.93-2.57-7.61-.26-16.83 4.46-23.29 6.06-8.31 15-10.49 18-11.23 6.08-1.48 11.31-.88 20.48.17l3 .85 3.31 1.81 1.2.45a10.87 10.87 0 002.92.67l1.28.12a5.17 5.17 0 014.18 2.87 11.87 11.87 0 010 2.15c-.52 5.41-4.87 8.84-5.62 9.41-4.82 3.67-7.73.78-11.4 3.47-5.41 4-.42 11.31-6.27 22-2.13 3.88-5 6.38-10.74 11.39a13.84 13.84 0 01-7.63 3.61z",
    className: "parcelShops_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.32 580.86a82.88 82.88 0 007.85 4.11l.41.18c3.7 1.66 7 2.91 10.57 2.31a4.9 4.9 0 002.15-1 8.44 8.44 0 003-4.13 22.52 22.52 0 001-10.82c0-.07-.16-.42 0-.58a.44.44 0 01.38-.08 6.69 6.69 0 002.73-.19 2 2 0 001-.93 2.17 2.17 0 00.06-1.54 5.1 5.1 0 00-1-2 8.07 8.07 0 01-1.08-1.68s0-.18-.12-.39-.15-.39-.16-.42a12.46 12.46 0 01-.48-1.86 19.67 19.67 0 01-.41-3.88 18.43 18.43 0 01.66-3.72 19.28 19.28 0 00.41-7.35 7.53 7.53 0 00-6.69-7c-.84-.18-5.33-1-8.09 1.66a8.43 8.43 0 00-1.82 3.3c-1.72 4.39-.77 5.68-2.14 9.08-1 2.42-3.08 5.77-5.45 5.78a2.56 2.56 0 01-1.66-.49c-.75-.61-.6-1.42-1.48-3.47a4.07 4.07 0 00-.83-1.49 3.54 3.54 0 00-4 0 4.94 4.94 0 00-1.82 3.31 11.84 11.84 0 00.33 6.27c.65 2.06 1.37 2.54 1.65 4.63a10.52 10.52 0 010 2.81 39.5 39.5 0 01-3 9.74c-2.36 6-3.76 9.64-2.15 11.56.35.41.56.42 2 1.12 3.94 1.87 4.16 2.6 7.8 4.46 1.35.68 6.58 3.35 7.31 2.35.21-.29 0-.74-.37-1.49a19.53 19.53 0 01-1.36-6.07c-.46-3.77.55-6.56 1-6.56.08 0 2.88.34 3.16.31l1.54.08h1.15",
    className: "parcelShops_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31,
    d: "M556.48 554a3.85 3.85 0 012.17-1.35 4 4 0 013.26.81"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.19,
    cy: 558.92,
    className: "parcelShops_after_svg__cls-16",
    rx: 2.72,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.67,
    cy: 559.5,
    className: "parcelShops_after_svg__cls-4",
    rx: 0.95,
    ry: 1.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.59 575.6a12.15 12.15 0 002 1.32 13.35 13.35 0 006.28 1.57M534.85 558.14a3.52 3.52 0 011.24 1.24 4.09 4.09 0 01-.13 3.72",
    className: "parcelShops_after_svg__cls-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.09 665.43a7.14 7.14 0 01-3.19.51 5.72 5.72 0 01-1-.19c-2.91-.75-12.2-1.69-23.78-4.29q-2.85-.65-5.62-1.32s-.2-2.15-.33-3.31c-.26-2.39-.58-4.13-.66-4.62-.32-2-.66-6.77-.66-19.49L525.28 634c.11 12.94-.12 20.87-.67 24.78a15.85 15.85 0 00.33 6.6 17.26 17.26 0 002 4.3c2.41 3.66 22.38 6.78 49.88 6.93l1 .52c4.65 2.52 5.14 3.35 7.38 4.35 1.82.82 4.25 1.91 6.87 1.09a7.54 7.54 0 003.19-2.09c3.41-3.47 3.48-8.43 3.43-10.06",
    className: "parcelShops_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Brille"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.48 563.25H558a4.15 4.15 0 010-8.3h1.52a4.15 4.15 0 110 8.3z",
    className: "parcelShops_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.09 559.27c2.23.11.57-.45 2.8-.35h9.92",
    className: "parcelShops_after_svg__cls-14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M538.83 558.18a13.83 13.83 0 01.3 7.58c-.75 2.85-2.47 5-1.53 6.21.28.36.92.55 2.21.94 1.47.44 2.21.66 2.53.4.77-.65-1-2.81-.91-6.19a12.25 12.25 0 01.76-3.74 30.94 30.94 0 013.56-7.7",
    className: "parcelShops_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.56 610.66q-.06 4.67 0 9.46a379.19 379.19 0 002.36 37.88l26.81 5.26v16.82c-2.26-.43-5.62-1-9.72-1.58-7.56-1-11.59-1.09-16.3-1.58-11.12-1.15-18.86-3.15-21.3-5.43-1.58-1.47-1.21-11.91-1.21-11.91-.09-4.91.17-10.5.43-16a223.24 223.24 0 00-.52-29.43",
    className: "parcelShops_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Oaket"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "640.97 665.91 606.6 675.48 606.6 637.7 640.97 628.09 640.97 665.91",
    className: "parcelShops_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "571.83 665.36 606.6 675.48 606.6 637.7 571.58 628.09 571.83 665.36",
    className: "parcelShops_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606.6 618.28 640.97 628.09 606.6 637.74 571.58 628.09 606.6 618.28",
    className: "parcelShops_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.22 646.51a1 1 0 01-.6-.19 1 1 0 01-.4-.81v-11.59a1 1 0 01.72-1l8.87-2.49h.27a1 1 0 011 1v11.35a1 1 0 01-.7 1l-8.87 2.73a1 1 0 01-.29 0z",
    className: "parcelShops_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.08 631.43v11.35l-8.86 2.73v-11.59l8.86-2.49m0-2a2 2 0 00-.54.07l-8.87 2.5a2 2 0 00-1.45 1.93v11.59a2 2 0 002 2 2.32 2.32 0 00.58-.08l8.87-2.74a2 2 0 001.41-1.91v-11.36a2 2 0 00-.79-1.6 2 2 0 00-1.21-.4z",
    className: "parcelShops_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 635.09a1 1 0 01-.3-.05l-32.93-10a1 1 0 010-1.91l10-2.8a.84.84 0 01.27 0 1 1 0 01.3 0l33.06 10.18a1 1 0 010 1.92l-10.11 2.66a.73.73 0 01-.29 0z",
    className: "parcelShops_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 621.24l33.06 10.19-10.06 2.66L586 624l10-2.8m0-2a2 2 0 00-.54.08l-10 2.79a2 2 0 000 3.84l32.93 10a2 2 0 00.59.09 2.24 2.24 0 00.51-.07l10.1-2.66a2 2 0 00.08-3.84l-33.06-10.19a2 2 0 00-.59-.09z",
    className: "parcelShops_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Junge-2",
    "data-name": "Junge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.92 678.42c-.15-2.93-.35-7.78-.34-13.78 0-16 1.46-20.62-.34-30.3a65.3 65.3 0 00-4.6-14.64c-.48-1.07-3.44-5.59-9.36-14.64-1.6-2.45-2.93-4.42-4.76-4.42-1.57 0-2.1 1.41-5.62 4.93-3.36 3.35-4.11 3.29-7 6.47a53.7 53.7 0 00-3.4 4.26c-2 2.75-5.22 8.12-8.35 18.55a147.72 147.72 0 00-4.25 21.28c-.8 5.75-1.67 13.6-2.06 23v7.33h49.56z",
    className: "parcelShops_after_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.71 593.15a83.56 83.56 0 01-8.1 4.23l-.41.19c-3.82 1.72-7.25 3-10.9 2.39a5 5 0 01-2.21-1 8.61 8.61 0 01-3.06-4.25 23.13 23.13 0 01-1-11.15c0-.07.17-.43 0-.6a.45.45 0 00-.39-.08 6.93 6.93 0 01-2.81-.2 2 2 0 01-1.08-.95 2.35 2.35 0 01-.07-1.6 5.34 5.34 0 011-2 8.25 8.25 0 001.12-1.74s.05-.19.12-.4l.17-.43a12.37 12.37 0 00.49-1.92 20.13 20.13 0 00.42-4 19 19 0 00-.68-3.83 19.8 19.8 0 01-.42-7.57 7.77 7.77 0 016.89-7.24c.87-.19 5.49-1.08 8.34 1.71A8.66 8.66 0 01670 556c1.78 4.52.8 5.85 2.22 9.36 1 2.5 3.16 5.94 5.61 6a2.69 2.69 0 001.71-.51c.77-.63.62-1.46 1.53-3.58a4.12 4.12 0 01.85-1.53 3.65 3.65 0 014.08 0c1.24.8 1.57 2.15 1.88 3.41a12.37 12.37 0 01-.34 6.47c-.68 2.11-1.42 2.61-1.71 4.76a11.58 11.58 0 000 2.89c.44 3.78 2 7.44 3.07 10.05 2.43 6.15 3.88 9.93 2.21 11.91-.35.42-.57.43-2.09 1.15-4.06 1.93-4.28 2.68-8 4.6-1.39.7-6.78 3.45-7.53 2.42-.22-.29.05-.76.38-1.53a20.47 20.47 0 001.41-6.25c.47-3.9-.57-6.77-1-6.77-.09 0-3 .35-3.26.32 0 0-1.61.1-1.59.09s.65 0-1.19-.06",
    className: "parcelShops_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 565.51a3.94 3.94 0 00-2.24-1.4 4.12 4.12 0 00-3.35.84",
    className: "parcelShops_after_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.28 569.74A3.66 3.66 0 00683 571a4.22 4.22 0 00.13 3.83",
    className: "parcelShops_after_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 555.74c-.78-.37.2-5.51 3.06-10a18.32 18.32 0 016.9-6.63 43.39 43.39 0 017.71-3c3.11-1.13 19.53-1.33 26.93 4 2 1.48 1 0 7.79 8.17 4.39 5.33-7.25 8.22-6.69 9.42 2.61 5.65.72 8.8.51 18.64-.16 7.61.8 14 2.55 25.53 1.39 9.15 2.73 14.52.26 16.09-2.16 1.37-5.32-1.37-11.23 0-2.59.6-3.36 2-4.09 1.53-1.82-1.15 3.82-8.31 3.32-18.13-.3-5.89-2.47-6-3.06-14.29-.41-5.67-.61-8.51.76-11.49.65-1.41 1.62-2.88 1.53-5.11a6.28 6.28 0 00-2.25-4.77c-.21-.15-2.18-1.51-3.83-.77-1 .47-1.54 1.59-2.3 3.32s-.67 2.43-1.28 2.81c-1.07.68-3.29 0-4.34-1.28a21.12 21.12 0 01-4.77-12.41c-.71-1.43-1.83-5.75-6-6.74a10.43 10.43 0 00-7.15 1.28c-2.92 1.69-3.76 4.09-4.33 3.83z",
    className: "parcelShops_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 661.54,
    x2: 661.38,
    y1: 568.17,
    y2: 569.56,
    className: "parcelShops_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 659.01,
    x2: 659.23,
    y1: 568.01,
    y2: 569.16,
    className: "parcelShops_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 656.98,
    x2: 658.06,
    y1: 568.31,
    y2: 569.56,
    className: "parcelShops_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 655.69,
    x2: 657.14,
    y1: 569.56,
    y2: 570.37,
    className: "parcelShops_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 663.68,
    x2: 662.8,
    y1: 568.98,
    y2: 569.91,
    className: "parcelShops_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663 570.22c0-.38-1.42-1.09-2.88-1.15-1 0-1.74.35-3.28 1.13-.06 0-.17.08-.18.18 0 .31 1.06.73 1.78.9a4.94 4.94 0 002.06.15 7.85 7.85 0 002.32-1c.07-.08.18-.13.18-.21z",
    className: "parcelShops_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.8,
    cy: 570.37,
    r: 1,
    className: "parcelShops_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.86 614.23a50.5 50.5 0 00-4.77 4.09 58.21 58.21 0 00-7 8.34c-3.22 4.45-5 6.64-5.45 8.51a15.56 15.56 0 004.25 15.15",
    className: "parcelShops_after_svg__cls-36"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.86,
    cy: 580.34,
    r: 4.18,
    fill: "#ffb3ac"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e67984",
    d: "M656 590.19a9.51 9.51 0 004.55-1 13.57 13.57 0 003.18-1.89s-.33.06-.93.12c-2.61.28-2.67.26-5.23.58a15.89 15.89 0 00-1.77.42l.07.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8795",
    d: "M663.63 587.24a3 3 0 01-.37.9 4 4 0 01-1.26 1.23 13.88 13.88 0 01-2.33 1.42 11.74 11.74 0 01-3.49 1l-.1-.64-.15-1h.49a6.94 6.94 0 001.76-.19 10.69 10.69 0 001.83-.62c.35-.14.73-.29 1.21-.53a12.26 12.26 0 001.61-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Fenster_rechts"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "parcelShops_after_svg__Fensterscheibe",
    points: "1195.15 691.07 1045.75 691.08 1045.75 514.62 1195.15 514.62 1195.15 691.07",
    className: "parcelShops_after_svg__cls-41"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1112.67 692.41 1112.67 611.03 1044.92 611.03 1044.92 595.33 1112.67 595.33 1112.67 513.94 1128.35 513.94 1128.35 595.33 1196.32 595.33 1196.32 611.03 1128.35 611.03 1128.35 692.41 1112.67 692.41",
    className: "parcelShops_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.35 514.94v81.39h68V610h-68v81.38h-13.68V610h-67.75v-13.7h67.75v-81.36h13.68m2-2h-17.68v81.39h-67.75V612h67.75v81.38h17.68V612h68v-17.7h-68v-81.36z",
    className: "parcelShops_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Fenster_links"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "parcelShops_after_svg__Fensterscheibe-2",
    width: 149.4,
    height: 176.46,
    x: 527.53,
    y: 514.94,
    className: "parcelShops_after_svg__cls-41",
    "data-name": "Fensterscheibe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "parcelShops_after_svg__Wand-2",
    fill: "#e2ccb5",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M446.5 452.48v376.64H1259v-389.4zm231.43 239.93h-151.4V513.94h151.4zm518.41 0h-151.4V514h151.4z",
    "data-name": "Wand"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__T\\xFCr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.13,
    height: 362.67,
    x: 784.67,
    y: 466.46,
    fill: "#c62a2b",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 796.55,
    y: 521.83,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 849.19,
    y: 521.83,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 902.19,
    y: 521.83,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 796.55,
    y: 594.38,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 849.19,
    y: 594.38,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 902.19,
    y: 594.38,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 796.37,
    y: 671.77,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 849,
    y: 671.77,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 902,
    y: 671.77,
    className: "parcelShops_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804.07,
    cy: 658.74,
    r: 7.7,
    fill: "#2a2118",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Dach-2",
    "data-name": "Dach"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1257.25,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-46",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1199.38,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-47",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1141.3,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-46",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1083.63,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-47",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1025.56,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-46",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 967.97,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-47",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 909.89,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-46",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 851.82,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-47",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 793.79,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-46",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 735.76,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-47",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 677.7,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-46",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.66,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-47",
    rx: 31.52,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.76,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-46",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.2,
    cy: 455.26,
    className: "parcelShops_after_svg__cls-47",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.54 455.26c0-14.55-6-27.3-15-34.52l-15 31.23v44c16.95-1.49 30-19.12 30-40.71z",
    className: "parcelShops_after_svg__cls-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.01 451.49 446.5 451.49 534.5 273.25 1259.02 273.25 1259.01 451.49",
    className: "parcelShops_after_svg__cls-7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "594.25 692.41 594.25 611.03 526.5 611.03 526.5 595.33 594.25 595.33 594.25 513.94 609.93 513.94 609.93 595.33 677.9 595.33 677.9 611.03 609.93 611.03 609.93 692.41 594.25 692.41",
    className: "parcelShops_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.93 514.94v81.39h68V610h-68v81.38h-13.67V610H527.5v-13.7h67.76v-81.36h13.67m2-2h-17.67v81.39H525.5V612h67.76v81.38h17.67V612h68v-17.7h-68v-81.36z",
    className: "parcelShops_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Schild"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.4 640.43c-1.6-4.32-25.08-7.75-53.83-7.75s-52.23 3.43-53.83 7.75h-.09v127.13h107.84V640.43z",
    className: "parcelShops_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.3,
    height: 115.87,
    x: 310.42,
    y: 646.28,
    className: "parcelShops_after_svg__cls-49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.77,
    height: 80.4,
    x: 305.65,
    y: 767.56,
    className: "parcelShops_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.77,
    height: 80.4,
    x: 408.72,
    y: 767.56,
    className: "parcelShops_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.77,
    height: 66.31,
    x: 357.18,
    y: 767.56,
    className: "parcelShops_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#474747",
    fontFamily: "Soulmate",
    fontSize: 27.04,
    transform: "matrix(1.04 0 0 1 321.34 700.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.03em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.68,
    y: 0
  }, "ake"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.94,
    y: 0,
    letterSpacing: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.75,
    y: 0,
    letterSpacing: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32.45,
    letterSpacing: "-.01em"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.49,
    y: 32.45
  }, "af"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.42,
    y: 32.45,
    fontFamily: "Lato-Regular,Lato"
  }, "\xE9"))), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Schild_paket"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.36 571.87 266.21 571.87 266.21 523.36 357.36 523.36 373.06 547.61 357.36 571.87",
    className: "parcelShops_after_svg__cls-49"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "319.75 501.4 305.65 523.36 329.61 523.36 319.75 501.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.02 560.65 320.33 567.21 320.33 541.32 340.02 534.74 340.02 560.65",
    className: "parcelShops_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.42 560.27 320.33 567.21 320.33 541.32 300.28 534.74 300.42 560.27",
    className: "parcelShops_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.33 528.01 340.02 534.74 320.33 541.35 300.28 534.74 320.33 528.01",
    className: "parcelShops_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.14 547.67a1 1 0 01-.58-.18 1 1 0 01-.42-.82v-7.94a1 1 0 01.68-1l5.08-1.7a.85.85 0 01.31-.06 1.06 1.06 0 01.59.19 1 1 0 01.41.81v7.78a1 1 0 01-.65.94l-5.08 1.87a1 1 0 01-.34.11z",
    className: "parcelShops_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.21 537v7.78l-5.07 1.87v-7.94l5.07-1.71m0-2a2 2 0 00-.63.11l-5.08 1.7a2 2 0 00-1.36 1.9v7.94a2 2 0 002 2 2.09 2.09 0 00.69-.12l5.08-1.87a2 2 0 001.3-1.88V537a2 2 0 00-.83-1.62 2 2 0 00-1.17-.38z",
    className: "parcelShops_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.43 539.84a1 1 0 01-.35-.06l-18.86-6.88a1 1 0 010-1.89l5.78-1.91a.91.91 0 01.32-.06.87.87 0 01.35.07l18.93 7a1 1 0 01.65 1 1 1 0 01-.7.93l-5.78 1.82a1 1 0 01-.34-.02z",
    className: "parcelShops_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.28 530l18.93 7-5.78 1.82-18.87-6.82 5.72-1.92m0-2a2.05 2.05 0 00-.64.11l-5.71 1.91a2 2 0 00-.05 3.78l18.86 6.88a2 2 0 00.69.12 2.08 2.08 0 00.6-.09l5.78-1.82a2 2 0 00.1-3.78l-18.94-7a2.06 2.06 0 00-.69-.13z",
    className: "parcelShops_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__Tische"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1198.43 708.34L1043 707.8l4.77-8.84a6 6 0 015.28-3.16h132.57a6 6 0 014.72 2.3z",
    className: "parcelShops_after_svg__cls-57"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1120.45,
    cy: 837.82,
    className: "parcelShops_after_svg__cls-58",
    rx: 43.96,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156.43,
    height: 14.93,
    x: 1042.23,
    y: 702.72,
    className: "parcelShops_after_svg__cls-59",
    rx: 7.47
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.12,
    height: 120.11,
    x: 1114.89,
    y: 717.71,
    className: "parcelShops_after_svg__cls-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.89 708.34l-155.38-.54 4.77-8.84a6 6 0 015.28-3.16h132.56a6 6 0 014.72 2.3z",
    className: "parcelShops_after_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156.43,
    height: 14.93,
    x: 524.01,
    y: 703.19,
    className: "parcelShops_after_svg__cls-59",
    rx: 7.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 602.23,
    cy: 838.29,
    className: "parcelShops_after_svg__cls-58",
    rx: 43.96,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.12,
    height: 120.11,
    x: 596.67,
    y: 718.18,
    className: "parcelShops_after_svg__cls-59"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.26 708.41l-155.38-.54 4.77-8.87a6 6 0 015.28-3.16H167.5a6 6 0 014.71 2.3z",
    className: "parcelShops_after_svg__cls-57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156.43,
    height: 14.93,
    x: 23.83,
    y: 702.14,
    className: "parcelShops_after_svg__cls-59",
    rx: 7.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.05,
    cy: 837.24,
    className: "parcelShops_after_svg__cls-58",
    rx: 43.96,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.12,
    height: 120.11,
    x: 96.49,
    y: 717.14,
    className: "parcelShops_after_svg__cls-59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_after_svg__St\\xFChle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.22 636.65l-1-3.26c-.78-1-3.44-1.47-4.82-.44l-12.93 9.66 7.65 2.69z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.54 636.13l-10.31 7.52 1.77 94.22 11.58-8.82v-91.4a1.88 1.88 0 00-3.04-1.52z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.28 729.05h-29.75L464 737.87l53.46 4.2-7.52-10.64a5.64 5.64 0 00-4.66-2.38z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.49 737.45v-91.9a4.49 4.49 0 00-4.5-4.5 4.5 4.5 0 00-4.5 4.5v98.68h62.89a6.78 6.78 0 00-6.79-6.78z",
    className: "parcelShops_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 510.23,
    y: 744.23,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 455.49,
    y: 744.23,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 502,
    y: 744.23,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 463.95,
    y: 744.23,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.32 633.33l1-3.26c.77-1 3.44-1.47 4.82-.44l12.93 9.66-7.66 2.68z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242 632.81l10.3 7.52-1.72 94.22-11.58-8.83v-91.39a1.88 1.88 0 013-1.52zM1209.25 725.72H1239l11.57 8.83-53.45 4.19 7.51-10.63a5.65 5.65 0 014.62-2.39z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 734.12v-91.9a4.51 4.51 0 014.5-4.5 4.5 4.5 0 014.5 4.5v98.69h-62.88a6.79 6.79 0 016.79-6.79z",
    className: "parcelShops_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 1196.16,
    y: 740.91,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 1200.23 792.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 1250.89,
    y: 740.91,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 1254.97 792.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 1204.39,
    y: 740.91,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 1208.465 785.905)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 1242.44,
    y: 740.91,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 1246.51 785.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.3 635.07l-1-3.25c-.78-1-3.45-1.47-4.83-.44L966.54 641l7.66 2.68z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.62 634.56l-10.31 7.51 1.69 94.22 11.57-8.82v-91.4a1.87 1.87 0 00-2.95-1.51zM1015.36 727.47H985.6l-11.6 8.82 53.45 4.2-7.45-10.63a5.65 5.65 0 00-4.64-2.39z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.57 735.87V644a4.5 4.5 0 00-4.5-4.5 4.51 4.51 0 00-4.5 4.5v98.69h62.88a6.79 6.79 0 00-6.79-6.79z",
    className: "parcelShops_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 1020.31,
    y: 742.66,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 965.57,
    y: 742.66,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 1012.07,
    y: 742.66,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 974.03,
    y: 742.66,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.24 634.9l1-3.25a4.09 4.09 0 014.82-.44l12.94 9.66-7.65 2.68z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.92 634.38l10.31 7.52-1.72 94.22-11.58-8.82v-91.4a1.88 1.88 0 012.99-1.52z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.18 727.3h29.75l11.58 8.82-53.46 4.2 7.52-10.63a5.62 5.62 0 014.61-2.39z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 735.7v-91.9a4.49 4.49 0 014.5-4.5 4.49 4.49 0 014.49 4.5v98.69h-62.91a6.79 6.79 0 016.79-6.79z",
    className: "parcelShops_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 686.08,
    y: 742.49,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 690.155 794.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 740.82,
    y: 742.49,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 744.89 794.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 694.32,
    y: 742.49,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 698.39 787.485)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 732.36,
    y: 742.49,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 736.435 787.485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79 729.92H-19l-11.57 8.82 53.45 4.2-7.48-10.63a5.65 5.65 0 00-4.61-2.39z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30 738.32v-91.9a4.5 4.5 0 00-4.5-4.5 4.49 4.49 0 00-4.5 4.5v98.69h62.88a6.79 6.79 0 00-6.79-6.79z",
    className: "parcelShops_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 15.74,
    y: 745.11,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 7.5,
    y: 745.11,
    className: "parcelShops_after_svg__cls-61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.75 635.78l1-3.26c.77-1 3.44-1.47 4.82-.44l12.93 9.66-7.66 2.68z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.43 635.26l10.3 7.52L246 737l-11.57-8.83v-91.39a1.88 1.88 0 013-1.52z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68 728.17h29.76L246 737l-53.45 4.19 7.51-10.63a5.65 5.65 0 014.62-2.39z",
    className: "parcelShops_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.47 736.57v-91.9a4.51 4.51 0 014.5-4.5 4.5 4.5 0 014.5 4.5v98.69h-62.88a6.79 6.79 0 016.79-6.79z",
    className: "parcelShops_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 191.59,
    y: 743.36,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 195.66 795.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 246.32,
    y: 743.36,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 250.395 795.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 199.82,
    y: 743.36,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 203.895 788.355)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 237.86,
    y: 743.36,
    className: "parcelShops_after_svg__cls-61",
    transform: "rotate(-180 241.94 788.355)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelShopsafter);
export default __webpack_public_path__ + "static/media/parcelShops.after.5e9be592.svg";
export { ForwardRef as ReactComponent };